import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Box, Typography } from '@mui/material';

import { PRIMARY_FONT } from '../../../theme/fontConstants';

const statusShape = PropTypes.shape({
  icon: PropTypes.node,
  color: PropTypes.string,
  displayName: PropTypes.string,
  fallback: PropTypes.string,
});

const StatusRow = ({ label, icon, color, displayName, fallback }) => (
  <Box display="flex" alignItems="center" gap={1}>
    <Typography sx={{ fontFamily: PRIMARY_FONT[500] }}>{label}</Typography>
    {icon}
    <Typography sx={{ fontFamily: PRIMARY_FONT[500], color }}>{displayName || fallback}</Typography>
  </Box>
);

StatusRow.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  color: PropTypes.string,
  displayName: PropTypes.string,
  fallback: PropTypes.string,
};

const DualStatusHeader = ({ showBoth = false, statusV1, statusV2 }) => {
  const statusLabel = LanguageConverter('userCard.header.status');
  const statusV1Label = LanguageConverter('userCard.header.statusV1');
  const statusV2Label = LanguageConverter('userCard.header.statusV2');

  if (!showBoth) {
    return <StatusRow label={statusLabel} {...statusV1} />;
  }

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <StatusRow label={statusV1Label} {...statusV1} />
      <StatusRow label={statusV2Label} fallback="—" {...statusV2} />
    </Box>
  );
};

DualStatusHeader.propTypes = {
  showBoth: PropTypes.bool,
  statusV1: statusShape.isRequired,
  statusV2: statusShape.isRequired,
};

export default DualStatusHeader;
